<div class="collapse-wrap">
    <div class="collapse-header" [ngClass]="{'active': expanded, 'show': expanded}" (click)="toggleExpanded()">
        <div class="caret">Impersonate</div>
    </div>
    @if (loading) {
        <ycn-loading-symbol></ycn-loading-symbol>
    } @else {
        <div class="theme-dark pb-2" [ngClass]="{'collapse': !expanded}">
            <label class="d-flex align-items-center mt-1 mb-10 pl-20 pr-20">
                <div class="form-label form-label-thin">
                    <div class="text-white mr-1">Work as</div>
                </div>
                <label class="custom-control custom-switch">
                    <input class="custom-control-input"
                           type="checkbox"
                           [checked]="workAsActive"
                           (click)="toggleWorkAs($event)"
                    >
                    <span class="custom-control-indicator"></span>
                </label>
            </label>
            <div class="dropdown ml-20 mr-20">
                <div
                    class="btn btn-block btn-outline btn-white"
                    (click)="setTargetUserMenuExpanded(!targetUserMenuExpanded)"
                >
                    <span class="d-flex align-items-center justify-content-between w-full text-default text-nowrap caret">
                        {{ getUserDisplayName(currentTargetUser) }}
                    </span>
                </div>
                @if (targetUserMenuExpanded) {
                    <div class="dropdown-menu dropdown-menu-right dropdown-menu-with-icons width-260 d-block"
                         (mouseleave)="setTargetUserMenuExpanded(false)"
                    >
                        <div class="ml-12 mr-12 pt-1 pb-1 theme-dark">
                            <ycn-search-bar
                                class="input-group field-input-group"
                                [autocompleterId]="autocompleterId"
                                [searchType]="'user_impersonation_permission'"
                                [placeholder]="'Search Team Member'"
                                [includeSearchIcon]="true"
                                [hideButton]="true"
                                (searchBarBlurHandler)="resetAutocompleter()"
                            ></ycn-search-bar>
                        </div>
                        <div class="dropdown-divider"></div>
                        <ycn-impersonation-target-user-list
                            [autocompleterId]="autocompleterId"
                            [initialTargetUserList]="targetUsers || []"
                            [currentTargetUser]="currentTargetUser"
                            (setCurrentTargetUserHandler)="setCurrentTargetUser($event)"
                        ></ycn-impersonation-target-user-list>
                    </div>
                }
            </div>
        </div>
    }
</div>
<!-- locks page if impersonation context has changed & refresh is required -->
<ycn-refresh-required-modal #refreshRequiredModal
    [refreshMessage]="'The active user for this tab has changed. Please refresh the page to continue.'">
</ycn-refresh-required-modal>
